/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconScriptX = createReactComponent("script-x", "IconScriptX", [
  [
    "path",
    {
      d: "M14 20h-8a3 3 0 0 1 0 -6h11a3 3 0 0 0 -3 3m7 -3v-8a2 2 0 0 0 -2 -2h-10a2 2 0 0 0 -2 2v8",
      key: "svg-0"
    }
  ],
  ["path", { d: "M17 17l4 4m0 -4l-4 4", key: "svg-1" }]
]);

export { IconScriptX as default };
//# sourceMappingURL=IconScriptX.js.map
